import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";
import {
  getDiagnosticReportWithImages,
  getDiagnosticResultWithImages,
  saveDiagnosticReportImages,
  saveDiagnosticResultImages,
} from "app/services/DiagnosticReportImageResultService";
import { getFileById } from "app/services/FileDescriptionExtService";
import { getByServiceRequestItemId } from "app/services/DiagnosticReportService";

toast.configure({
  autoClose: 2000,
  draggable: false,
  limit: 3,
});

export default class TreatmentReportImageResultStore {
  onViewDiagnosticReport = null;
  onViewDiagnosticResult = null;
  onViewDiagnosticReportBySRI = null;

  constructor() {
    makeAutoObservable(this);
  }

  resetStore = () => {
    this.onViewDiagnosticReport = null;
    this.onViewDiagnosticResult = null;
  };

  handleGetDiagnosticReportWithImages = async (serviceRequestItemId) => {
    try {
      const { data: diagnosticReportBySRI } = await getByServiceRequestItemId(
        serviceRequestItemId
      );

      this.onViewDiagnosticReportBySRI = diagnosticReportBySRI;

      if (diagnosticReportBySRI?.id) {
        const { data } = await getDiagnosticReportWithImages(
          diagnosticReportBySRI?.id
        );

        const formatItems = await Promise.all(
          (data.reportImages || []).map(async (item) => {
            const response = await getFileById(item?.fileDescription?.id);

            // Convert blob to object URL for image display
            const imageUrl = URL.createObjectURL(
              new Blob([response.data], { type: "image/png" })
            );

            return {
              data: item,
              src: imageUrl,
              thumb: imageUrl,
              alt: item?.name,
            };
          })
        );
        this.onViewDiagnosticReport = {
          ...data,
          ...this.receiveTreatmentResult,
          reportImagesFormat: formatItems,
        };
      }
    } catch (error) {
      console.error(error);
      toast.error("Có lỗi xảy ra khi lấy ảnh điều trị");
    }
  };

  handleSaveDiagnosticReportImages = async (values) => {
    try {
      const { data } = await saveDiagnosticReportImages(values);

      toast.success("Đã lưu ảnh kết quả điều trị");

      return data;
    } catch (error) {
      console.error(error);
      toast.error("Có lỗi xảy ra khi luw ảnh kết quả điều trị");
    }
  };

  handleGetDiagnosticResultWithImages = async (diagnosticResultId) => {
    try {
      const { data } = await getDiagnosticResultWithImages(diagnosticResultId);
      this.onViewDiagnosticResult = {
        ...data,
      };
    } catch (error) {
      console.error(error);
      toast.error("Có lỗi xảy ra khi lấy ảnh điều trị của bước");
    }
  };

  handleSaveDiagnosticResultImages = async (values) => {
    try {
      const { data } = await saveDiagnosticResultImages(values);

      toast.success("Đã lưu ảnh kết quả điều trị của bước");

      return data;
    } catch (error) {
      console.error(error);
      toast.error("Có lỗi xảy ra khi luw ảnh kết quả điều trị");
    }
  };
}
